// Import model
import { DataviewOtgUserResponse } from '../models/DataviewOtgUserResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgUserRequest } from '../models/FilterOtgUserRequest';
import { OtgUser } from '../models/OtgUser';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgUserRequestSerializer } from './FilterOtgUserRequestSerializer';
import { OtgUserSerializer } from './OtgUserSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgUserResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgUserResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgUserResponse instance
   */
  static deserialize(json: string): DataviewOtgUserResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgUserResponse instance
   */
  static fromObject(obj: any): DataviewOtgUserResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgUserResponse');
    }


    const instance: DataviewOtgUserResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgUserSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgUserRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgUserResponse instances
   */
  static deserializeArray(json: string): DataviewOtgUserResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgUserResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgUserResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgUserResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgUserResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgUserSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgUserRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgUserResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgUserResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
